import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import cx from 'classnames';
import tooltipCss from 'Styles/tooltip.scss'; // eslint-disable-line import/no-unresolved import/extensions
import WveSettingsPanelNav from 'Components/WveSettingsPanel/WveSettingsPanelNav/WveSettingsPanelNav';
import SettingsPanel from 'PreviewComponents/SideBar/Panels/SettingsPanel';
import EventsPanel from 'PreviewComponents/SideBar/Panels/EventsPanel';
import SharingPanel from 'PreviewComponents/SideBar/Panels/SharingPanel';
import { colourWhite, colourMasterLight } from 'Styles/colors.css';
import { UI } from 'SharedConstants/';
import { SELECTED_CONTAINER, SETTINGS_PANEL_WIDTH } from 'PreviewConstants/';
import { deselectAdStateContainers } from 'PreviewActions/customLayoutActions';

const Container = styled.div`
    position: fixed;
    margin-bottom: 0;
    z-index: 10001;
    border-left: 1px solid ${colourMasterLight};
    width: ${SETTINGS_PANEL_WIDTH}px;
    right: -${SETTINGS_PANEL_WIDTH}px;
    bottom: 0px;
    top: 0px;
    background-color: ${colourWhite};

`;

const PanelContainer = styled.div`
  padding: 0 30px;
`;

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'view',
      eventLog: [],
    };
  }
  componentDidMount() {
    window.document.body.addEventListener('preview-tracking', this.updateEventLog);
  }
  updateEventLog = (event) => {
    const { eventLog } = this.state;
    var time = (new Date()).toLocaleTimeString().slice(0, -3);
    var evtStr=`${time}`;

    if(event.detail.name.indexOf('percent-played') > -1) {
      evtStr = `${evtStr} ${event.detail.name} ${event.detail.meta.ap}`;
    }else if(event.detail.name.indexOf('click-through') > -1) {
      evtStr = `${evtStr} ${event.detail.name} ${atob(event.detail.meta.l)}`;
      const evtTarget = event.detail.target;
      const clickthroughURL = evtTarget ? evtTarget.getAttribute('data-href') : '';
      evtStr = `${evtStr} ${clickthroughURL}`;
    }else if(event.detail.name.indexOf('click') > -1) {
      evtStr = `${evtStr} ${event.detail.name} ${atob(event.detail.meta.l)}`;
    }else{
      evtStr = `${evtStr} ${event.detail.name}`;
    }
    this.setState({ eventLog: [evtStr].concat(eventLog)});
  };
  toggleSideBar = (event) => {
    event.stopPropagation();
    document.getElementById('previewSettings').classList.toggle('open');
  };
  toggleTab = (tabName) => {
    if (this.state.activeTab === tabName) {
      return;
    }
    this.setState({ activeTab: tabName });
  }
  render() {
    const { selectedContainer, deselectAdStateContainers } = this.props;
    const { toggleSideBar } = this;
    const { activeTab, eventLog } = this.state;

    const panelMapping = {};
    panelMapping.view = SettingsPanel;
    panelMapping.events = EventsPanel;
    panelMapping.sharing = SharingPanel;

    const SelectedPanel = panelMapping[activeTab]; //(activeTab === 'view') ? SettingsPanel : SharingPanel;

    return (
      <Container id="previewSettings" ref="previewSettings" className="wve-drawer wve-drawer-vertical" onClick={deselectAdStateContainers}>
        <button onClick={toggleSideBar} className={cx('wve-drawer-button', tooltipCss.base, tooltipCss.left)} data-original-title="Settings">
          <i className="pg pg-settings_small" />
        </button>
        <PanelContainer>
          <WveSettingsPanelNav
            toggleTab={this.toggleTab}
            topBarElements={['view', 'events', 'sharing']}
            activeTab={activeTab}
          />
          <SelectedPanel eventLog={eventLog} />
        </PanelContainer>
      </Container>);
  }
}

// export default SideBar;

SideBar.propTypes = {
  selectedContainer: PropTypes.string,
};

SideBar.defaultProps = {
  selectedContainer: 'standard',
};

const mapStateToProps = state => ({
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

const mapDispatchToProps = dispatch => ({
  deselectAdStateContainers: () =>
    dispatch(deselectAdStateContainers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/SideBar.jsx